import { Eye, EyeOff, Loader, Lock, X } from "lucide-react";
import React, { useState } from "react";
import { notify, getPractice, can_visit } from "../../helpers";
import { changePassword } from "../../services/users";
import Spacing from "../Spacing";

export default function ChangePasswordModal(props) {
  const {
    activeModal,
    setActiveModal = () => {}
  } = props;

  const [enableLoader, setEnableLoader] = useState(false);
  const [oldPassword, setOldPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [error, setError] = useState("");

  const [informations, setInformations] = useState({
    account_id: getPractice("account_id"),
    current_password: "",
    new_password: "",
    confirm_password: ""
  });

  const handleChange = (e) => {
    setInformations({ ...informations, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(can_visit("change_password")) {
      e.target.disabled = true;
      setEnableLoader(true);

      if (informations.new_password !== informations.confirm_password) {
        setError("New password and confirm password do not match.");
        e.target.disabled = false;
        setEnableLoader(false);
        return;
      } else {
        setError("");

        try {
          const result = await changePassword(informations)
    
          if (result.data.status === 'error') {
            notify('error', result?.data?.message);
            setEnableLoader(false);
          } else {
            notify('success', result?.data?.message);
            setActiveModal(!activeModal);
            setEnableLoader(false);
          }
          e.target.disabled = false;
        } catch (error) {
          notify('error', 'Invalid current password');
          e.target.disabled = false;
          setEnableLoader(false);
        }
      }
    }
  };

  return (
    <>
      {activeModal && (
        <div className="docpro_modal_wrap">
          <div className="docpro_modal_overlay" ></div>
          <div className="docpro_modal relative" style={{ maxWidth: '435px', padding: '40px' }}>
            <div className="absolute right-0 top-0 p-3 pointer mt-1 mr-1" onClick={() => setActiveModal(!activeModal)}>
              <X width={18} height={18} />
            </div>

            <div className="docpro_login_card_wrap">
              <form onSubmit={handleSubmit} className="docpro_login_card" style={{ maxWidth: '435px' }}>
                <div className="docpro_text_center">
                  <h1 className="docpro_mb_0">Change your password?</h1>
                </div>
                <Spacing lg="30" sm="30" />
                
                <label className="docpro_fw_500 docpro_primary_color"> Current Password <span className="docpro_red_color">*</span></label>
                <div className="docpro_form_field_with_icon">
                  <input
                    name="current_password"
                    type={oldPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    className="docpro_form_field size_lg"
                    onChange={handleChange}
                    required
                    minLength={4}
                  />
                  <Lock
                    width={18}
                    height={18}
                    className="docpro_form_field_icon"
                  />
                  { oldPassword ?
                    <Eye onClick={()=>setOldPassword(false)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: '#b0b0b0' }} />
                  :
                    <EyeOff onClick={()=>setOldPassword(true)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: '#b0b0b0' }} />
                  }
                </div>
                <Spacing lg="15" sm="15" />

                <label className="docpro_fw_500 docpro_primary_color"> New Password <span className="docpro_red_color">*</span></label>
                <div className="docpro_form_field_with_icon">
                  <input
                    name="new_password"
                    type={newPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    className="docpro_form_field size_lg"
                    onChange={handleChange}
                    required
                    minLength={8}
                  />
                  <Lock
                    width={18}
                    height={18}
                    className="docpro_form_field_icon"
                  />
                  { newPassword ?
                    <Eye onClick={()=>setNewPassword(false)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: '#b0b0b0' }} />
                  :
                    <EyeOff onClick={()=>setNewPassword(true)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: '#b0b0b0' }} />
                  }
                </div>
                <Spacing lg="15" sm="15" />

                <label className="docpro_fw_500 docpro_primary_color"> Confirm Password <span className="docpro_red_color">*</span></label>
                <div className="docpro_form_field_with_icon">
                  <input
                    name="confirm_password"
                    type={confirmPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    className="docpro_form_field size_lg"
                    onChange={handleChange}
                    required
                    minLength={8}
                  />
                  <Lock
                    width={18}
                    height={18}
                    className="docpro_form_field_icon"
                  />
                  { confirmPassword ?
                    <Eye onClick={()=>setConfirmPassword(false)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: '#b0b0b0' }} />
                  :
                    <EyeOff onClick={()=>setConfirmPassword(true)} width={18} height={18} className="docpro_form_field_icon pointer" style={{ color: '#b0b0b0' }} />
                  }
                </div>
                <Spacing lg="15" sm="15" />
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <Spacing lg="20" sm="20" />
                {can_visit("change_password") && (
                  <button
                    type="submit"
                    className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn"
                  >
                    <span>Change Password</span>
                  </button>
                )}
              </form>
            </div>

            {enableLoader && (
              <div className="absolute top-0 left-0 flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', backgroundColor: 'rgb(230 230 230 / 70%)', borderRadius: '12px' }}>
                <span className="docpro_loading">
                  <Loader width={42} height={42} style={{ color: 'var(--accent)' }} />
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
